import Order from '@lib/Order';
import { DashboardBenefit } from '../dashboard/types';

export interface Action {
  type: ActionType;
  value?: any;
}

export enum ActionType {
  INDEX_ITEMS = 'index_items',
  FILTER_ITEMS = 'filter_items',
  SEARCH_ITEMS = 'search_items',
  INCREMENT_ITEM = 'increment_item',
  DECREMENT_ITEM = 'decrement_item',
  REMOVE_ITEM = 'remove_item',
  SET_INITIAL_DATA = 'set_initial_data',
}

export enum ItemType {
  SINGLE = 'SINGLE',
  COLLECTION = 'COLLECTION',
}

export interface DashboardItem {
  id?: string;
  price?: string;
  count_description?: string;
  type?: ItemType;
  image_url?: string;
  title?: string;
  subtitle?: string;
  tags?: string;
  product_code?: string;
  count?: number;
}

export interface DashboardOrder {
  total: number;
  catalog_id?: string;
  items?: any;
}

export interface CatalogState {
  allItems: [DashboardItem];
  items: [DashboardItem];
  benefit: DashboardBenefit;
  order?: Order;
  selectedFilterIndex: number;
  search: any;
}

export enum FilterType {
  TAG = 'TAG',
  PRICE = 'PRICE',
}

export interface BasketItem {
  id: string;
}

export interface Filter {
  type: FilterType;
  name: string;
  icon?: any;
}
